import { AbstractControl, ValidationErrors } from '@angular/forms';
import moment from 'moment';
import { Injectable } from '@angular/core';

/**
 * This service handles more complex validation of availability form.
 */
@Injectable({ providedIn: 'root' })
export class AvailabilityValidator {

  /** The regex value for availability's start time and end time, which must be in 15 minutes intervals. */
  static TIME_REGEX = '(0\\d|1\\d|2[0-3]):(00|15|30|45)(:00)?';
  /** Minimum shift left in hours. An availability cannot be less than this value. */
  static MIN_SHIFT_LENGTH_IN_HOURS = 5;

  /**
   * Validates, if availability is not too short and if its start time is not later than end time.
   * @param control a control of availability's form.
   */
  static validateShiftLength(control: AbstractControl): ValidationErrors | null {
    const startTime = moment(control.get('startTime').value, 'HH:mm:ss');
    const endTime = moment(control.get('endTime').value, 'HH:mm:ss');

    const duration = moment.duration(endTime.diff(startTime));
    const hours = duration.asHours();

    if (startTime.isSameOrAfter(endTime)) {
      return {
        startTimeIsAfterEndTime: true
      };
    }

    if (hours < AvailabilityValidator.MIN_SHIFT_LENGTH_IN_HOURS) {
      return {
        tooShortShift: true
      };
    }

    return null;
  }
}
